<template>
  <div class="password-page">
    <el-card class="password-card" shadow="never">
      <div class="password-header">
        <div>
          <h1>修改密码</h1>
          <p>{{ needChangePassword ? '首次登录请先完成密码修改' : '为了账号安全，建议定期更新密码' }}</p>
        </div>
        <el-tag v-if="needChangePassword" type="warning" effect="plain">首次改密</el-tag>
      </div>

      <el-alert
        v-if="needChangePassword"
        class="password-alert"
        title="当前账号首次登录后必须修改密码，修改完成后将自动退出，请使用新密码重新登录。"
        type="warning"
        :closable="false"
        show-icon
      />

      <el-form ref="formRef" :model="form" :rules="rules" label-position="top" @submit.native.prevent="submit">
        <el-form-item label="当前密码" prop="currentPassword">
          <el-input
            v-model.trim="form.currentPassword"
            type="password"
            placeholder="请输入当前密码"
            show-password
            autocomplete="current-password"
            @keyup.enter.native="submit"
          />
        </el-form-item>

        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model.trim="form.newPassword"
            type="password"
            placeholder="请输入新密码，长度 6-32 位"
            show-password
            autocomplete="new-password"
            @keyup.enter.native="submit"
          />
        </el-form-item>

        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            v-model.trim="form.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
            autocomplete="new-password"
            @keyup.enter.native="submit"
          />
        </el-form-item>

        <div class="password-actions">
          <el-button v-if="!needChangePassword" @click="$router.back()">取消</el-button>
          <el-button type="primary" :loading="submitting" @click="submit">确认修改</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { changeAdminPassword } from '../api/admin'
import { clearAdminAuth, getAdminUser } from '../utils/auth'

export default {
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入新密码'))
        return
      }
      if (value !== this.form.newPassword) {
        callback(new Error('两次输入的新密码不一致'))
        return
      }
      callback()
    }

    return {
      submitting: false,
      form: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        currentPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 32, message: '新密码长度需在 6 到 32 位之间', trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    needChangePassword() {
      const admin = getAdminUser()
      return Number(admin && admin.needChangePassword) === 1
    }
  },
  methods: {
    async submit() {
      if (this.submitting) {
        return
      }
      const valid = await new Promise(resolve => {
        this.$refs.formRef.validate(ok => resolve(ok))
      })
      if (!valid) {
        return
      }
      this.submitting = true
      try {
        await changeAdminPassword(this.form)
        clearAdminAuth()
        this.$message.success('密码修改成功，请使用新密码重新登录')
        this.$router.replace('/login')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.password-page {
  padding: 24px;
}

.password-card {
  max-width: 560px;
  border-radius: 20px;
}

.password-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.password-header h1 {
  margin: 0 0 8px;
  font-size: 24px;
}

.password-header p {
  margin: 0;
  color: #7c6d5d;
}

.password-alert {
  margin-bottom: 20px;
}

.password-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
